<template>
	<div>
		<transition name="fade">
			<Row v-if="mainTable.sarchShow" :gutter="16">
				<Col span="24">
				<search-card :form="mainTable.searchForm" :table-load-event="getTableRecords"
					:table-search="mainTable.tableSearch" />
				</Col>
			</Row>
		</transition>
		<Card :padding="0" :bordered="false" :dis-hover="true">
			<Row :gutter="16">
				<Col span="24">
				<div class="global-tool-bar">
					<div class="left-bar">
						<span class="title">认可关系列表</span>
					</div>
					<div class="right-bar">
						<Button type="primary" size="small" class="btns" shape="circle" icon="ios-search"
							@click="mainTable.sarchShow = !mainTable.sarchShow">搜索</Button>
					</div>
				</div>
				</Col>
			</Row>
			<Row :gutter="16">
				<Col span="24">
				<stand-pagination-table :columns="mainTable.columns" :data="mainTable.data" :extHeight="60"
					:loading="mainTable.loading" :table-search="mainTable.tableSearch"
					:table-load-event="getTableRecords" />
				</Col>
			</Row>
		</Card>
	</div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import {
    statusAcceptFormat
} from '@/libs/baseModelFormat';
import {
    dateTimeRender
} from '@/libs/tableRowTimeRender';
import { getSeedFarmAcceptCusMgrList } from '@/api/modules/account-management/customerManager-user-management';

export default {
    name: 'relatiionshipList',
    components: {
        SearchCard,
        StandPaginationTable
    },
    props: {
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            mainTable: {
                columns: [{
                    title: '行号',
                    type: 'index',
                    width: 80,
                    align: 'center'
                },
                {
                    title: '苗场编号',
                    key: 'seedFarmCode',
                    align: 'center'
                },
                {
                    title: '苗场名称',
                    key: 'seedFarmName',
                    align: 'center'
                },
                {
                    title: '联系人',
                    key: 'seedFarmContact',
                    align: 'center'
                },
                {
                    title: '联系电话',
                    key: 'seedFarmContactPhone',
                    align: 'center'
                },
                {
                    title: '苗场区域',
                    key: 'areaName',
                    align: 'center'
                },
                {
                    title: '客户经理账号',
                    key: 'userName',
                    align: 'center'
                },
                {
                    title: '客户经理姓名',
                    key: 'userCustomerManagerName',
                    align: 'center'
                },
                {
                    title: '客户经理手机号',
                    key: 'userCustomerManagerPhone',
                    align: 'center'
                },
                {
                    title: '客户经理区域',
                    key: 'userCustomerManagerAreaName',
                    align: 'center'
                },
                {
                    title: '创建时间',
                    key: 'createTime',
                    align: 'center',
                    render: (h, params) => dateTimeRender(h, params.row.createTime)
                },
                {
                    title: '更新时间',
                    key: 'modifyTime',
                    align: 'center',
                    render: (h, params) => dateTimeRender(h, params.row.modifyTime)
                },
                {
                    title: '是否认可',
                    key: 'recordStatus',
                    align: 'center',
                    width: 80,
                    render: (h, params) => {
                        let txt = params.row.recordStatus == 1 ? "是" : "否";
                        return h('div', [
                            h('span', {
                                style: {
                                    color: params.row.recordStatus == 1 ? "#006400" : "#FF0000"
                                }
                            }, txt)
                        ]);
                    }
                }
                ],
                data: [],
                sarchShow: false,
                searchForm: [{
                    label: '苗场',
                    type: 'Input',
                    value: '',
                    name: 'concat(tt.seedFarmCode, tt.seedFarmName) ',
                    sql: 'like'
                },
                {
                    label: '联系人',
                    type: 'Input',
                    value: '',
                    name: 'tt.seedFarmContact',
                    sql: 'like'
                },
                {
                    label: '联系电话',
                    type: 'Input',
                    value: '',
                    name: 'tt.seedFarmContactPhone',
                    sql: 'like'
                },
                {
                    label: '苗场介绍',
                    type: 'Input',
                    value: '',
                    name: 'tt.seedFarmIntroduction',
                    sql: 'like'
                }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted() {
        this.getTableRecords();
    },
    methods: {
        getTableRecords(reset = false) {
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }

            getSeedFarmAcceptCusMgrList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.loading = false;
            }).catch(() => {
                this.mainTable.loading = false;
            });
        }
    }
};
</script>

<style>
</style>
